__turbopack_context__.v({
  "active": "ProductGallery-module__Nwe3Ia__active",
  "gallery": "ProductGallery-module__Nwe3Ia__gallery",
  "loupe": "ProductGallery-module__Nwe3Ia__loupe",
  "mainImage": "ProductGallery-module__Nwe3Ia__mainImage",
  "mainImageContainer": "ProductGallery-module__Nwe3Ia__mainImageContainer",
  "thumbnail": "ProductGallery-module__Nwe3Ia__thumbnail",
  "thumbnails": "ProductGallery-module__Nwe3Ia__thumbnails",
});
